import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../lib/contexts/AuthContext';
import { type ReactNode } from 'react';
import { loginPathFor } from '../../../lib/utils/loginPath';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-canvas">
        <div className="text-center">
          <svg
            className="animate-spin motion-reduce:animate-none h-12 w-12 text-ink-muted mx-auto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <p className="mt-4 text-ink-muted">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated — carrying `?next=` (Story 30.2)
  // so sign-in returns them to this exact path and query.
  if (!isAuthenticated) {
    return <Navigate to={loginPathFor(location)} replace />;
  }

  return <>{children}</>;
}
